import script from "./SharedReadingLens.vue?vue&type=script&setup=true&lang=js"
export * from "./SharedReadingLens.vue?vue&type=script&setup=true&lang=js"

import "./SharedReadingLens.vue?vue&type=style&index=0&id=66482548&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-66482548"]])

export default __exports__